import { apiGet, apiPost } from "./http";

export interface AbnormalOrderSummary {
  guestCount: number;
  enrollmentCount: number;
  count: number;
}

export interface AbnormalGuestOrderDto {
  outTradeNo: string;
  tenantLegacyId: string;
  tenantName: string;
  wxOpenId: string;
  sessionLegacyId: string;
  activityLegacyId: string;
  activityTitle: string;
  guestName: string;
  guestPhone: string;
  idNumber: string;
  amountFen: number;
  status: string;
  wxTransactionId: string;
  createdAt: string;
  paidAt: string;
  registrationLegacyId: string;
}

export interface AbnormalEnrollmentOrderDto {
  outTradeNo: string;
  tenantLegacyId: string;
  tenantName: string;
  wxOpenId: string;
  applicationLegacyId: string;
  applicantName: string;
  applicantPhone: string;
  levelLabel: string;
  applicationReviewStatus: string;
  anomalyReason: "no_application" | "application_missing" | "awaiting_payment" | string;
  amountFen: number;
  status: string;
  wxTransactionId: string;
  createdAt: string;
  paidAt: string;
}

export interface AbnormalGuestOrderListResponse {
  page: number;
  pageSize: number;
  total: number;
  items: AbnormalGuestOrderDto[];
}

export interface AbnormalEnrollmentOrderListResponse {
  page: number;
  pageSize: number;
  total: number;
  items: AbnormalEnrollmentOrderDto[];
}

export function fetchAbnormalOrderSummary() {
  return apiGet<AbnormalOrderSummary>("/api/platform/abnormal-orders/summary");
}

/** @deprecated 使用 fetchAbnormalOrderSummary */
export function fetchAbnormalGuestOrderSummary() {
  return apiGet<{ count: number }>("/api/platform/abnormal-orders/guest-registration/summary");
}

export function fetchAbnormalGuestOrders(params?: {
  tenantLegacyId?: string;
  keyword?: string;
  page?: number;
  pageSize?: number;
}) {
  const q = new URLSearchParams();
  if (params?.tenantLegacyId) q.set("tenantLegacyId", params.tenantLegacyId);
  if (params?.keyword) q.set("keyword", params.keyword);
  if (params?.page) q.set("page", String(params.page));
  if (params?.pageSize) q.set("pageSize", String(params.pageSize));
  const qs = q.toString();
  return apiGet<AbnormalGuestOrderListResponse>(
    `/api/platform/abnormal-orders/guest-registration${qs ? `?${qs}` : ""}`,
  );
}

export function fetchAbnormalEnrollmentOrders(params?: {
  tenantLegacyId?: string;
  keyword?: string;
  page?: number;
  pageSize?: number;
}) {
  const q = new URLSearchParams();
  if (params?.tenantLegacyId) q.set("tenantLegacyId", params.tenantLegacyId);
  if (params?.keyword) q.set("keyword", params.keyword);
  if (params?.page) q.set("page", String(params.page));
  if (params?.pageSize) q.set("pageSize", String(params.pageSize));
  const qs = q.toString();
  return apiGet<AbnormalEnrollmentOrderListResponse>(
    `/api/platform/abnormal-orders/enrollment${qs ? `?${qs}` : ""}`,
  );
}

export function retryAbnormalGuestOrderFinalize(outTradeNo: string) {
  return apiPost<{
    success: boolean;
    guestRegistrationLegacyId?: string;
    failureReason?: string;
    status: string;
    alreadyFinalized?: boolean;
  }>(`/api/platform/abnormal-orders/guest-registration/${encodeURIComponent(outTradeNo)}/retry-finalize`, {});
}

export function retryAbnormalEnrollmentOrderFinalize(outTradeNo: string) {
  return apiPost<{
    success: boolean;
    applicationLegacyId?: string;
    reviewStatus?: string;
    failureReason?: string;
    status: string;
  }>(`/api/platform/abnormal-orders/enrollment/${encodeURIComponent(outTradeNo)}/retry-finalize`, {});
}
